import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black select-none pointer-events-none z-0" style={{ color: 'oklch(var(--background-200))' }}>
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6" style={{ color: 'oklch(var(--foreground-900))' }}>This page has not been generated</h1>
        <p className="mt-2 text-base font-mono" style={{ color: 'oklch(var(--foreground-500))' }}>{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl" style={{ color: 'oklch(var(--foreground-600))' }}>Tell me more about this page, so I can generate it</p>
        <Link to="/" className="btn-primary text-sm px-6 py-2.5 rounded-lg mt-6 inline-flex">
          <i className="ri-home-line mr-2"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}